import './cookieConsent.css';

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const CAT_FUNCTIONALITY = "functionality";
const CAT_SECURITY = "security";
const CAT_UNCATEGORIZED = "uncategorized";

// For convenience, define constants for Google Tag Manager/Analytics services:
const SERVICE_AD_STORAGE = 'ad_storage'
const SERVICE_AD_USER_DATA = 'ad_user_data'
const SERVICE_AD_PERSONALIZATION = 'ad_personalization'
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage'
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage'
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage'
const SERVICE_SECURITY_STORAGE = 'security_storage'

function updateGtagConsent() {
  const analyticsAllowed = window.CookieConsent?.allowedCategory?.(CAT_ANALYTICS);
  const advertisementAllowed = window.CookieConsent?.allowedCategory?.(CAT_ADVERTISEMENT);
  const functionalityAllowed = window.CookieConsent?.allowedCategory?.(CAT_FUNCTIONALITY);
  const uncategorizedAllowed = window.CookieConsent?.allowedCategory?.(CAT_UNCATEGORIZED);
  // const securityAllowed = window.CookieConsent?.allowedCategory?.(CAT_SECURITY);

  window.gtag('consent', 'update', {
    [SERVICE_ANALYTICS_STORAGE]: analyticsAllowed ? 'granted' : 'denied',
    [SERVICE_AD_STORAGE]: advertisementAllowed ? 'granted' : 'denied',
    [SERVICE_AD_USER_DATA]: advertisementAllowed ? 'granted' : 'denied',
    [SERVICE_AD_PERSONALIZATION]: advertisementAllowed ? 'granted' : 'denied',
    [SERVICE_FUNCTIONALITY_STORAGE]: functionalityAllowed ? 'granted' : 'denied',
    [SERVICE_PERSONALIZATION_STORAGE]: functionalityAllowed ? 'granted' : 'denied',
    [CAT_UNCATEGORIZED]: uncategorizedAllowed ? 'granted' : 'denied'
    // [SERVICE_SECURITY_STORAGE]: securityAllowed ? 'granted' : 'denied'
  });

  if (analyticsAllowed) {
    window.gtag('config', 'G-DVRWQWNP1V', {
      anonymize_ip: true,
      page_title: document.title,
      page_path: window.location.pathname
    });
  }

  if (advertisementAllowed) {
    gtag('config', 'AW-1025823284', {
      'allow_ad_personalization_signals': true
    });
  }
}

const isMobile = window.matchMedia('(max-width: 640px)').matches;


export const cookieConsentConfig = {
  onFirstConsent: () => {
    updateGtagConsent();
  },

  onChange: () => {
    updateGtagConsent();
  },

  onConsent: () => {
    updateGtagConsent();
  },

  autoClearCookies: true,
  mode: "opt-in",

  guiOptions: {
    consentModal: {
      position: isMobile ? 'center' : 'bottom left',
      flipButtons: true,
    },
    preferencesModal: {
      layout: 'box',
      flipButtons: true
    }
  },

  categories: {
    [CAT_NECESSARY]: {
      enabled: true,
      readOnly: true
    },
    // Add a services section for analytics similar to advertisements
    [CAT_ANALYTICS]: {
      enabled: false,
      autoClear: {
        cookies: [
          { name: /^_ga/ },
          { name: '_gid' },
          { name: 'pardot' }
        ]
      },
      services: {
        googleAnalytics: {
          label: 'Google Analytics',
          onAccept: () => {
            gtag('consent', 'update', {
              'analytics_storage': 'granted'
            });

            gtag('config', 'G-DVRWQWNP1V', {
              anonymize_ip: true,
              page_title: document.title,
              page_path: window.location.pathname
            });
          },
          onReject: () => {
            gtag('consent', 'update', {
              'analytics_storage': 'denied'
            });
          }
        },
        pardot: {
          label: 'Pardot Tracking',
          onAccept: () => {
            window.piAId = '498911';
            window.piCId = '19158';
            window.piHostname = 'pi.pardot.com';

            (function () {
              function async_load() {
                var s = document.createElement('script');
                s.type = 'text/javascript';
                s.src = (document.location.protocol === 'https:' ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
                var c = document.getElementsByTagName('script')[0];
                c.parentNode.insertBefore(s, c);
              }
              if (window.attachEvent) {
                window.attachEvent('onload', async_load);
              } else {
                window.addEventListener('load', async_load, false);
              }
            })();
          },
        }
      }
    },

    [CAT_ADVERTISEMENT]: {
      enabled: false,
      autoClear: {
        cookies: [
          { name: /^_gcl/ },
          { name: /^_gads/ },
          { name: /^visitor_id/ }
        ]
      },

      services: {
        fbPixel: {
          label: 'Facebook Pixel',

          onAccept: () => {
            (function () {
              !(function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                  n.callMethod ?
                    n.callMethod.apply(n, arguments) :
                    n.queue.push(arguments)
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e); t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
              })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

              // 2) Initialize
              fbq('init', '146604117226401');
              fbq('track', 'PageView');
            })();
          }

          // onReject: () => {
          // (autoClearCookies should just remove the '_fbp')
          // }
        },

        googleAds: {
          label: 'Google Ads',
          onAccept: () => {
            gtag('consent', 'update', {
              'ad_storage': 'granted',
              'ad_user_data': 'granted',
              'ad_personalization': 'granted'
            });

            gtag('config', 'AW-1025823284', {
              'allow_ad_personalization_signals': true
            });
          },
          onReject: () => {
            gtag('consent', 'update', {
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'ad_personalization': 'denied'
            });
          }
        },

        pardot: {
          label: 'Pardot Tracking',
          onAccept: () => {
            window.piAId = '498911';
            window.piCId = '19158';
            window.piHostname = 'pi.pardot.com';

            (function () {
              function async_load() {
                var s = document.createElement('script');
                s.type = 'text/javascript';
                s.src = (document.location.protocol === 'https:' ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
                var c = document.getElementsByTagName('script')[0];
                c.parentNode.insertBefore(s, c);
              }
              if (window.attachEvent) {
                window.attachEvent('onload', async_load);
              } else {
                window.addEventListener('load', async_load, false);
              }
            })();
          },
          // onReject: () => {            
          // }
        }
      },
    },
    [CAT_FUNCTIONALITY]: {
      enabled: true,
      autoClear: {
        cookies: [
          { name: /^_func/ }
        ]
      }
    },
    [CAT_UNCATEGORIZED]: {
      enabled: false,
      autoClear: {
        cookies: [
          { name: /^_unc/ },
          { name: /^lpv497911/ }
        ]
      },
    }
  },


  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: `
            <p>
              We value your privacy
            </p>`,
          description: `
            We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking 'Accept All', you consent to our use of cookies.<br><br>
            <a href="https://aspph.org/cookie-policy/" class="cookie-policy" target="_blank">Click here to view our cookie policy.</a>`,
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Customize',
        },
        preferencesModal: {
          title: 'Customize Consent Preferences',
          acceptNecessaryBtn: 'Reject All',
          savePreferencesBtn: 'Save My Preferences',
          acceptAllBtn: 'Accept All',
          closeIconLabel: 'Close modal',

          sections: [
            {
              title: 'Why we track cookies',
              description: "We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below.\n\nThe cookies that are categorized as 'Necessary' are stored on your browser as they are essential for enabling the basic functionalities of the site.\n\nWe also use third-party cookies that help us analyze how you use this website, store your preferences, and provide the content and advertisements that are relevant to you. These cookies will only be stored in your browser with your prior consent.\n\nYou can choose to enable or disable some or all of these cookies but disabling some of them may affect your browsing experience.",
            },
            {
              title: 'Necessary',
              description: 'Necessary cookies are required to enable the basic features of this site, such as providing secure log-in or adjusting your consent preferences. These cookies do not store any personally identifiable data.',
              linkedCategory: CAT_NECESSARY,
              cookieTable: {
                headers: {
                  name: 'Name',
                  purpose: 'Purpose',
                  expiration: 'Expiration'
                },
                body: [
                  {
                    name: '_GRECAPTCHA',
                    purpose: "Set by Google recaptcha service to identify bots and to protect the website against malicious spam attacks.",
                    expiration: '2 years'
                  },
                  {
                    name: 'cc_cookie',
                    purpose: "CookieConsent sets this cookie to remember users' consent preferences so that their preferences are respected on subsequent visits to this site. It does not collect or store any personal information about the site visitors.",
                    expiration: '1 year'
                  },
                ]
              }
            },
            {
              title: 'Analytics',
              description: 'Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.',
              linkedCategory: CAT_ANALYTICS,
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Domain',
                  purpose: 'Purpose',
                  expiration: 'Expiration'
                },
                body: [
                  {
                    name: '_ga',
                    domain: 'google.com',
                    purpose: "Google Analytics sets this cookie to calculate visitor, session and campaign data and track site usage for the site's analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognise unique visitors.",
                    expiration: '2 years'
                  },
                  {
                    name: '_ga_',
                    domain: 'google.com',
                    purpose: 'Google Analytics sets this cookie to store and count page views.',
                    expiration: '2 years'
                  },
                  {
                    name: 'pardot',
                    domain: 'pardot.com',
                    purpose: 'The pardot cookie is set while the visitor is logged in as a Pardot user. The cookie indicates an active session and is not used for tracking.',
                    expiration: 'Session'
                  }
                ]
              }
            },
            {
              title: 'Advertisement',
              description: 'Advertisement cookies are used to provide visitors with customised advertisements based on the pages you visited previously and to analyse the effectiveness of the ad campaigns.',
              linkedCategory: CAT_ADVERTISEMENT,
              cookieTable: {
                headers: {
                  name: 'Name',
                  purpose: 'Purpose',
                  expiration: 'Expiration'
                },
                body: [
                  {
                    name: 'visitor_id*',
                    purpose: "Pardot sets this cookie to store a unique user ID.",
                    expiration: '6 months'
                  },
                  {
                    name: 'visitor_id*-hash',
                    purpose: "Pardot sets this cookie to store a unique user ID.",
                    expiration: '6 months'
                  },
                  {
                    name: 'test_cookie',
                    purpose: "doubleclick.net sets this cookie to determine if the user's browser supports cookies.",
                    expiration: 'never'
                  },
                  {
                    name: '_gcl_au',
                    domain: 'google.com',
                    purpose: 'Google Tag Manager sets the cookie to experiment advertisement efficiency of websites using their services.',
                    expiration: '3 months'
                  },
                  {
                    name: '_fbp',
                    domain: 'facebook.com',
                    purpose: 'Facebook sets this cookie to display advertisements when either on Facebook or on a digital platform powered by Facebook advertising after visiting the website.',
                    expiration: '3 months'
                  },
                ]
              }
            },

            {
              title: 'Uncategorized',
              description: 'Other uncategorized cookies are those without classification but may still be necessary for certain functionalities of the website.',
              linkedCategory: CAT_UNCATEGORIZED,
              cookieTable: {
                headers: {
                  name: 'Name',
                  purpose: 'Purpose',
                  expiration: 'Expiration'
                },
                body: [
                  {
                    name: 'lpv497911',
                    purpose: "Track page views during single browsing session.",
                    expiration: 'Session'
                  }
                ]
              }
            },
            {
              title: 'More information',
              description: 'For any queries in relation to our policy on cookies and your choices, please contact us.'
            }
          ]

        }
      }
    }
  }
};